import type { FaireProductEntity } from "../../entity_types/product";

export const p_c7d2cjbn5x: FaireProductEntity = {
  token: "p_c7d2cjbn5x",
  type: "product",
  name: "RAWMYGOD Nut Butter Balls - Cacao & Hazelnut",
  brandToken: "b_46hn96hpk5",
  brandName: "Wilton Mettler LLC",
  imageUrl:
    "https://cdn.faire.com/fastly/ca79d53931e71099fcbe4bef79e85d01da339de07c872a9e966a93e4f142ded3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/14332a5edb4bd3008031ae4aac381ee86e1342e0170eb0cf08e05b9741cc63d8.jpeg",
    "https://cdn.faire.com/fastly/f034dc6e7710f24e1a3f19f2060703fbd5f20b60951d32c851dbd974b72cb542.jpeg",
    "https://cdn.faire.com/fastly/8eb73c9b8f7f7698e461c914dde3f928e1ebfdaaba122803f73c01aaa0dde584.jpeg",
  ],
  priceDollars: 3.67,
  description:
    "\nGluten Free, Vegan, No Added Sugar. Nutritious Snack: Made with wholesome ingredients like dates, raw hazelnuts, and cacao, with a creamy hazelnut butter center. Indulgent Treat: A flavorful, guilt-free indulgence that’s as delicious as it is wholesome. Versatile Delight: Can be enjoyed as a snack, dessert, or energy boost. Cold-processed to preserve nutritional value; not heated above 104° Fahrenheit\n\n\nIndulge in the delectable RAWMYGOD NUT BUTTER BALLS CACAO & HAZELNUT, a heavenly treat made from a wholesome blend of dates, raw hazelnuts, and cacao, with a smooth hazelnut‑butter center. These bite‑sized delights are crafted with care, offering a satisfying mix of textures and naturally sweet, nutty, and chocolatey flavors. Made with premium ingredients, they’re a guilt‑free indulgence you can enjoy anytime. Whether you’re after a quick snack or a light dessert, these nut butter balls are sure to delight. Treat yourself or share the joy with loved ones.\n",
  tags: [],
  msrpDollars: 6.58,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:54:31.478Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
